import Ctor from './ctor'

const PREFIXCLS = 'tooltip'

export default {
  name: 'tooltip',
  bind (el, binding, vnode, oldVnode) {
    let ctor = new Ctor()
    let options = Object.assign({
      prefixCls: PREFIXCLS,
      placement: 'bottom',
      visible: false,
      content: '',
      delay: 0,
      disabled: false,
      always: false
    }, binding.value)
    // 绑定事件
    el.addEventListener('mouseenter', (e) => {
      ctor.setVisible(e, options, binding, el, 1)
    })
    el.addEventListener('mouseleave', (e) => {
      ctor.setVisible(e, options, binding, el, 0)
    })
    el.addEventListener('focus', (e) => {
      ctor.setVisible(e, options, binding, el, 1)
    })
    el.addEventListener('blur', (e) => {
      ctor.setVisible(e, options, binding, el, 0)
    })
    Object.keys(options).map(key => {
      if (key !== 'onPopperShow' && key !== 'onPopperHide') {
        switch (Object.prototype.toString.call(options[key])) {
          case '[object String]':
          case '[object Number]':
            el.dataset[key] = options[key]
            break
          case '[object Boolean]':
            el.dataset[key] = options[key] ? 1 : 0
            break
          default:
            el.dataset[key] = options[key] ? options[key] : 0
            break
        }
      }
    })
    binding.value.ctor = ctor
  },
  inserted (el, binding, vnode, oldVnode) {
    let options = el.dataset
    let ctor = binding.value.ctor
    let popperOpt = {
      gpuAcceleration: false,
      boundariesElement: 'viewport',
      forceAbsolute: true
    }
    ctor.createPopper(options, binding, popperOpt, el)
  },
  update (el, binding, vnode, oldVnode) {
    // let options = el.dataset
    let ctor = binding.value.ctor
    // let popperOpt = {
    //   gpuAcceleration: false,
    //   boundariesElement: 'viewport',
    //   forceAbsolute: true
    // }
    // ctor.popperJS ? ctor.destoryPopper() : ctor.createPopper(options, binding, popperOpt, el)
    ctor.updatePopperOps(el, binding)
  },
  unbind (el, binding, vnode, oldVnode) {
    let ctor = binding.value.ctor
    const popper = ctor.popperEl
    if (ctor.popperJS && popper) {
      if (popper.parentNode) {
        popper.parentNode.removeChild(popper)
      }
      ctor.popperJS.destroy()
      ctor.popperJS = null
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/tooltip/d-tooltip.js